import { Category } from "@CommonApi/categories";
import { omniAtom } from "src/utils/atoms";

export const importVariantRestrictionModalDataAtom = omniAtom({
  prefix: "src/modals/importVariantRestriction",
  key: "data",
  value: null as null | Category,
});
